import { useDispatch } from 'react-redux'

export function useDispatcher (dispatcher, ...args) {
  return dispatcher(useDispatch(), ...args)
}
